export class SeedReservationGrowerOrderData {
  growerOrderId: number;
  growerName: string;
  growerAddress: string;
  orderID: string;
  unit: string;
  accountNo: string;
  lastUpdatedAt: Date;
  orderType: string;
  city: string;
  state: string;
  zip: string;
  gln: string;
  gmk: number;
  EmailTo: string;
  wfusB2BEnablement: string;
  isAccountRIB: boolean;
  productLine: string;
  marketingBrand: string;
  seedReservationHeaderID: number;
  selectedItemLIst: any[] = [];
}
